import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { QueueTab } from "@/components/admin/QueueTab";
import { PlansTab } from "@/components/admin/PlansTab";
import { UsersTab } from "@/components/admin/UsersTab";
import { LedgerTab } from "@/components/admin/LedgerTab";

const triggerCls =
  "flex-1 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-[#0B0B0F] text-[#A0A0A0]";

export default function AdminControl() {
  const { user } = useAuth();
  // Backend enforces 403 on all /api/admin endpoints; this is just UX routing
  if (!user?.is_admin) return <Navigate to="/circle" replace />;

  return (
    <AppShell wide>
      <div data-testid="admin-control-page">
        <h1 className="font-serif text-3xl font-bold tracking-tight text-white mb-1">Admin Control</h1>
        <p className="text-sm text-[#A0A0A0] mb-8">The vault, the ledger, the circle.</p>

        <Tabs defaultValue="queue">
          <TabsList className="w-full bg-[#15151A] border border-[#D4AF37]/20 mb-6">
            <TabsTrigger value="queue" data-testid="admin-tab-queue" className={triggerCls}>
              Queue
            </TabsTrigger>
            <TabsTrigger value="plans" data-testid="admin-tab-plans" className={triggerCls}>
              Plans
            </TabsTrigger>
            <TabsTrigger value="users" data-testid="admin-tab-users" className={triggerCls}>
              Users
            </TabsTrigger>
            <TabsTrigger value="ledger" data-testid="admin-tab-ledger" className={triggerCls}>
              Ledger
            </TabsTrigger>
          </TabsList>
          <TabsContent value="queue" className="mt-0">
            <QueueTab />
          </TabsContent>
          <TabsContent value="plans" className="mt-0">
            <PlansTab />
          </TabsContent>
          <TabsContent value="users" className="mt-0">
            <UsersTab />
          </TabsContent>
          <TabsContent value="ledger" className="mt-0">
            <LedgerTab />
          </TabsContent>
        </Tabs>
      </div>
    </AppShell>
  );
}
